import {
  Box,
  Button,
  Divider,
  Flex,
  FormControl,
  FormLabel,
  Image,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  Stack,
  Text,
  VStack,
  useToast,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { actionSignIn, actionSignUp } from "../../api/postApi";
import { waitTime } from "../../utils/waitTime";
import Cookies from "js-cookie";
import { useDispatch } from "react-redux";
import {
  Link,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { FaEye, FaEyeSlash, FaMobileAlt, FaUserFriends } from "react-icons/fa";
import { RiUser3Fill, RiUserSmileFill } from "react-icons/ri";
import { BiKey, BiTransferAlt } from "react-icons/bi";
import { MdMail } from "react-icons/md";
import GoogleLoginButton from "../Singin/components/googleLogin";
import TelegramLogin from "../Singin/components/telegramLogin";
import CustomInput from "../../components/InputComponents/customInput";
import {
  accountExpressForInput,
  cantSpecialSymbol,
  disabledSpaceForInput,
  passwordExpressForInput,
  phoneExpressForInput,
} from "../../regex_constanst";
import GetParams from "../../utils/getParams";
import { api } from "../../api/baseApi";
import { notice } from "../../redux/action/action";
import { TbPassword } from "react-icons/tb";
import GoogleLoginV2 from "../Singin/components/GoogleLogin_v2";
import { CgPassword } from "react-icons/cg";
import useGetAgentName from "../../hook/useGetAgentName";
import useTransCode from "../../hook/useTransCode";
import useInviteCode from "../../hook/useInviteCode";
import { COMMON_WEB_PATH } from "../../constant";
import i18next from "i18next";

/* 萬客(zun789)註冊不做 E-mail 驗證,見下方表單說明 */
const SHOW_EMAIL_VERIFICATION = false;

const iconStyle = "text-gray-300";

/*
 * 掃推廣碼註冊頁(比照星曜,2026-09-29):欄位順序 帳號 → 暱稱 → 密碼 → 確認密碼 → 邀請碼。
 * 新增的欄位沿用本站帳號/密碼欄的外觀,樣式集中在這裡,五個欄位長得一樣。
 */
const FIELD_BOX_PROPS = {
  display: "flex",
  alignItems: "center",
  pl: "15px",
  gap: "5px",
  sx: {
    bgImage: `url(${COMMON_WEB_PATH}/theOne/modal/word_background.png)`,
    bgSize: "100% 100%",
    bgRepeat: "no-repeat",
    bgPosition: "center",
  },
};
const FIELD_INPUT_PROPS = {
  bg: "transparent",
  border: "none",
  px: "5px",
  _focus: {
    border: "none",
    outline: "none !important",
    boxShadow: "none !important",
  },
};
const ACCOUNT_ICON = `${COMMON_WEB_PATH}/theOne/signIn/account_icon.svg`;
const PWD_ICON = `${COMMON_WEB_PATH}/theOne/signIn/pwd_icon.svg`;
const FieldIcon = ({ src }) => (
  <Box>
    <Image minW="23px" minH="23px" maxW="23px" maxH="23px" src={src} />
  </Box>
);

const SignupForm = () => {
  const { t } = useTranslation();
  const i18n = (key, props) => t(`header.${key}`, { ...props });
  const i18n_common = (key) => t(`common.${key}`);
  const i18n_common_form = (key) => t(`settings.form.${key}`);
  const i18n_formHint = (key, props) => t(`formHint.${key}`, { ...props });
  const i18n_backend_response = (key) => t(`backend_response.${key}`);

  const toast = useToast();

  const [searchParams, setSearchParams] = useSearchParams();

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const agent_name = useGetAgentName();

  const [formData, setFormData] = useState({
    user_name: "",
    nick_name: "",
    password: "",
    confirm_password: "",
    real_name: "",
    mobile: "",
    email: "",
    verifiedCode: "",
    code: "",
  });
  const [buttonLoading, setButtonLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [emailLoading, setEmailLoading] = useState(false);
  const [emailSendStatus, setEmailSendStatus] = useState(false);
  const [seconds, setSeconds] = useState(0);

  const trans_code = useTransCode();
  const invite_code = useInviteCode();

  const {
    user_name,
    nick_name,
    password,
    confirm_password,
    real_name,
    mobile,
    email,
    code,
  } = formData;

  const unlimit_code = GetParams("uac");

  /*
   * 邀請碼(掃推廣碼註冊頁,比照星曜 star888 KioskRegisterDialog,2026-09-29):
   *   必填、網址自動帶入、可修改。
   * ⚠️ 網址要自己讀:App.js 是在 useEffect 裡才把 ?invite= 寫進 cookie,
   *    子元件的 useState 初值比它早跑 —— 第一次掃碼進來時 cookie 還是空的。
   *    invitecode 是魔方分享連結用過的寫法,一併吃下。
   */
  const [invite, setInvite] = useState(
    () =>
      searchParams.get("invite") ||
      searchParams.get("invitecode") ||
      Cookies.get("invite") ||
      invite_code ||
      ""
  );

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSeePassword = () => {
    setShowPassword(!showPassword);
  };

  const handleVerifyEmail = async () => {
    setEmailLoading(true);
    await api
      .post("/getCode", {
        email: email,
      })
      .then((data) => {
        setSeconds(60);
        setEmailSendStatus(true);
        dispatch(
          notice({
            title: data?.message,
            type: "success",
          })
        );
      })
      .finally(() => {
        setEmailLoading(false);
      });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // const open_registration = window?.open_registration == 1;
    // if (!open_registration) {
    //   dispatch(
    //     notice({
    //       title: i18n("registration_closed"),
    //       type: "error",
    //     })
    //   );
    //   return;
    // }

    /* 暱稱必填(最多 20 字由 input maxLength 限制);純空白也擋 */
    if (!nick_name.trim()) {
      dispatch(
        notice({
          title: `${i18n_common("pleaseInput")} ${i18n_common_form("nick_name")}`,
          type: "error",
        })
      );
      return;
    }
    /* 確認密碼只做前端比對,不送後端(同星曜) */
    if (password !== confirm_password) {
      dispatch(
        notice({ title: i18n_formHint("password_not_match"), type: "error" })
      );
      return;
    }
    /* 邀請碼必填;純空白也擋(原生 required 擋不住空白) */
    const inviteValue = invite.trim();
    if (!inviteValue) {
      dispatch(
        notice({ title: i18n_formHint("invite_required"), type: "error" })
      );
      return;
    }

    setButtonLoading(true);

    await actionSignUp({
      memId: user_name,
      nick_name: nick_name.trim(),
      passwd: password,
      true_name: real_name,
      mobile: mobile,
      email: email,
      unlimit_code: unlimit_code,
      invite: inviteValue,
      code: code,
    })
      .then((data) => {
        Cookies.remove("token");
        toast({
          title: i18n_backend_response("Sign up success"),
          description: "We will login for you now, please wait a moment.",
          status: "success",
          duration: 1500,
          isClosable: true,
        });
      })
      .finally(() => {
        setButtonLoading(false);
      });

    await actionSignIn({
      account: user_name,
      passwd: password,
      trans_code: trans_code,
    })
      .then((data) => {
        if (Cookies.get("token")) {
          Cookies.remove("token");
        }
        Cookies.set("token", data.token, { expires: 365 });
        Cookies.remove("trans_code");

        dispatch({
          type: "INITIALIZE_API",
          navigate: navigate,
        });

        navigate("/");
      })
      .finally(() => {
        setButtonLoading(false);
      });
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }

      if (seconds === 0) {
        clearInterval(interval);
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  });

  return (
    <form className="max-w-[350px]" onSubmit={handleSubmit}>
      <VStack spacing={`15px`}>
        <FormControl
          display={"flex"}
          alignItems={"center"}
          pl="15px"
          gap="5px"
          isRequired
          sx={{
            bgImage: `url(${COMMON_WEB_PATH}/theOne/modal/word_background.png)`,
            bgSize: "100% 100%",
            bgRepeat: "no-repeat",
            bgPosition: "center",
          }}
        >
          <Box>
            <Image
              minW="23px"
              minH="23px"
              maxW="23px"
              maxH="23px"
              src={`${COMMON_WEB_PATH}/theOne/signIn/account_icon.svg`}
            />
          </Box>
          <InputGroup w="100%" bgSize="100% 100%">
            <Input
              type="text"
              bg="transparent"
              name="user_name"
              value={user_name}
              onChange={handleInputChange}
              placeholder={i18n_formHint("includeSixEnglishAndNumber")}
              title={i18n_formHint("includeSixEnglishAndNumber")}
              pattern={accountExpressForInput}
              border="none"
              px="5px"
              _focus={{
                border: "none",
                outline: "none !important",
                boxShadow: "none !important",
              }}
            />
          </InputGroup>
        </FormControl>
        {/* 暱稱(必填,最多 20 字) */}
        <FormControl {...FIELD_BOX_PROPS} isRequired>
          <FieldIcon src={ACCOUNT_ICON} />
          <InputGroup w="100%">
            <Input
              {...FIELD_INPUT_PROPS}
              type="text"
              name="nick_name"
              value={nick_name}
              onChange={handleInputChange}
              maxLength={20}
              placeholder={i18n_common_form("nick_name")}
              title={i18n_common_form("nick_name")}
              autoComplete="nickname"
            />
          </InputGroup>
        </FormControl>
        <FormControl
          display={"flex"}
          alignItems={"center"}
          pl="15px"
          gap="5px"
          isRequired
          sx={{
            bgImage: `url(${COMMON_WEB_PATH}/theOne/modal/word_background.png)`,
            bgSize: "100% 100%",
            bgRepeat: "no-repeat",
            bgPosition: "center",
          }}
        >
          <Box>
            <Image
              minW="23px"
              minH="23px"
              maxW="23px"
              maxH="23px"
              src={`${COMMON_WEB_PATH}/theOne/signIn/pwd_icon.svg`}
            />
          </Box>
          <InputGroup w="100%" bgSize="100% 100%">
            <Input
              type={showPassword ? "text" : "password"}
              bg="transparent"
              name="password"
              value={password}
              onChange={handleInputChange}
              placeholder={i18n_formHint("includeEightEnglishAndNumber")}
              title={i18n_formHint("includeEightEnglishAndNumber")}
              pattern={passwordExpressForInput}
              border="none"
              px="5px"
              _focus={{
                border: "none",
                outline: "none !important",
                boxShadow: "none !important",
              }}
            />
            <InputRightElement top="unset" bottom="0px">
              {showPassword ? (
                <FaEyeSlash
                  className="cursor-pointer"
                  onClick={handleSeePassword}
                />
              ) : (
                <FaEye className="cursor-pointer" onClick={handleSeePassword} />
              )}
            </InputRightElement>
          </InputGroup>
        </FormControl>
        {/* 確認密碼(只做前端比對,不送後端);顯示/隱藏跟著上面的眼睛 */}
        <FormControl {...FIELD_BOX_PROPS} isRequired>
          <FieldIcon src={PWD_ICON} />
          <InputGroup w="100%">
            <Input
              {...FIELD_INPUT_PROPS}
              type={showPassword ? "text" : "password"}
              name="confirm_password"
              value={confirm_password}
              onChange={handleInputChange}
              placeholder={i18n_common_form("confirm_password")}
              title={i18n_common_form("confirm_password")}
              autoComplete="new-password"
            />
          </InputGroup>
        </FormControl>
        {/* 邀請碼(必填、網址自動帶入、可修改) */}
        <FormControl {...FIELD_BOX_PROPS} isRequired>
          <FieldIcon src={ACCOUNT_ICON} />
          <InputGroup w="100%">
            <Input
              {...FIELD_INPUT_PROPS}
              type="text"
              name="invite"
              value={invite}
              onChange={(e) => setInvite(e.target.value)}
              placeholder={i18n_common_form("invitedCode")}
              title={i18n_common_form("invitedCode")}
              autoComplete="off"
            />
          </InputGroup>
        </FormControl>
        {trans_code && (
          <FormControl isRequired>
            <FormLabel>{i18n_common_form("轉移代碼")}</FormLabel>
            <InputGroup>
              <InputLeftElement pointerEvents="none">
                <BiTransferAlt className={iconStyle} />
              </InputLeftElement>
              <Input
                type={"text"}
                variant={`brandPrimary`}
                name="trans_code"
                value={trans_code}
                isDisabled={true}
              />
            </InputGroup>
          </FormControl>
        )}
        {unlimit_code && (
          <FormControl>
            <FormLabel>{i18n_common_form("refer_code")}</FormLabel>
            <InputGroup>
              <InputLeftElement pointerEvents="none">
                <FaUserFriends className={iconStyle} />
              </InputLeftElement>
              <Input
                type={`text`}
                variant={`brandPrimary`}
                name="unlimit_code"
                isDisabled={true}
                value={unlimit_code}
              />
            </InputGroup>
          </FormControl>
        )}{" "}
        {/* 2026-10-07 萬客驗收:註冊頁拿掉 E-mail 驗證(信箱 + 驗證碼兩欄都不顯示)。
            原本吃後台注入的 window.email_verification;要恢復把 SHOW_EMAIL_VERIFICATION 改回
            `window?.email_verification == 1` 即可。
            ⚠️ 後台若仍開著 email 驗證,後端可能要求 code —— 請一併把後台設定關掉。 */}
        {SHOW_EMAIL_VERIFICATION ? (
          <Flex gap="10px" w="100%" alignItems={`flex-end`}>
            <FormControl isRequired>
              <FormLabel>{i18n_common_form("email")}</FormLabel>
              <InputGroup>
                <InputLeftElement pointerEvents="none">
                  <MdMail className={iconStyle} />
                </InputLeftElement>
                <Input
                  type="email"
                  variant={`brandPrimary`}
                  name="email"
                  value={email}
                  onChange={handleInputChange}
                  placeholder={`${i18n_common(
                    "pleaseInput"
                  )} ${i18n_common_form("email")}`}
                />
              </InputGroup>
            </FormControl>
            <Button
              type="button"
              onClick={() => {
                handleVerifyEmail();
              }}
              isDisabled={emailLoading || seconds > 0}
              isLoading={emailLoading}
            >
              {emailSendStatus ? seconds : i18n_formHint("verify")}
            </Button>
          </Flex>
        ) : null}
        {emailSendStatus && (
          <FormControl isRequired>
            <FormLabel>{i18n_formHint("verify_code")}</FormLabel>
            <InputGroup>
              <InputLeftElement pointerEvents="none">
                <CgPassword className={iconStyle} />
              </InputLeftElement>
              <Input
                type="text"
                variant={`brandPrimary`}
                name="code"
                value={code}
                onChange={handleInputChange}
              />
            </InputGroup>
          </FormControl>
        )}
        {/* {agent_name && (
          <FormControl>
            <FormLabel>{i18n_common_form("agent_refer_code")}</FormLabel>
            <InputGroup>
              <InputLeftElement pointerEvents="none">
                <FaUserFriends className={iconStyle} />
              </InputLeftElement>
              <Input
                type={`text`}
                variant={`brandPrimary`}
                name="agent_name"
                isDisabled={true}
                value={agent_name}
              />
            </InputGroup>
          </FormControl>
        )} */}
        <Flex
          justifyContent={"center"}
          alignItems={"center"}
          gap="5px"
          w="100%"
        >
          <Button
            sx={{
              bgImage: `url(${COMMON_WEB_PATH}/theOne/button/confirm_background.png)`,
              bgSize: "contain",
              bgRepeat: "no-repeat",
              bgPosition: "center",
              background: "transparent",
              _hover: {
                bgImage: `url(${COMMON_WEB_PATH}/theOne/button/confirm_background.png)`,
              },
              _active: {
                bgImage: `url(${COMMON_WEB_PATH}/theOne/button/confirm_background.png)`,
              },
              h: "65px",
            }}
            isLoading={buttonLoading}
            disabled={buttonLoading}
            py="20px"
            type="submit"
            w="130px"
          >
            <Text mb="5px" color="#0C5426" fontWeight={900} fontSize="23px">
              {i18n("signup")}
            </Text>
          </Button>
          <Box
            sx={{
              bgImage: `url(${COMMON_WEB_PATH}/theOne/button/cancel_background.png) !important`,
              bgSize: "contain !important",
              bgRepeat: "no-repeat !important",
              bgPosition: "center !important",
              background: "transparent",
              _hover: {
                bgImage: `url(${COMMON_WEB_PATH}/theOne/button/cancel_background.png)`,
              },
              _active: {
                bgImage: `url(${COMMON_WEB_PATH}/theOne/button/cancel_background.png)`,
              },
              h: "65px",
            }}
            isLoading={buttonLoading}
            disabled={buttonLoading}
            py="20px"
            as={Link}
            to="../signin"
            w="130px"
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
          >
            <Text mb="5px" color="#353535" fontWeight={900} fontSize="23px">
              {i18n("signin")}
            </Text>
          </Box>
          {/* <GoogleLoginButton
            setButtonLoading={setButtonLoading}
            buttonLoading={buttonLoading}
          /> */}
          {/* <GoogleLoginV2 />
          <TelegramLogin
            setButtonLoading={setButtonLoading}
            buttonLoading={buttonLoading}
          /> */}
        </Flex>
      </VStack>
    </form>
  );
};

export default SignupForm;
